import { Link } from 'react-router'
import { Card, Skeleton } from '@/components/ui'
import { CommunityIcon } from '@/components/common/CommunityIcon'
import { formatCount } from '@/lib/format'
import { plural } from '@/lib/i18n'
import { humanizeSlug, useCommunity } from '@/lib/community'
import type { CommunitySlotProps } from './slots'

/**
 * Compact header shown above content below 1024 px, where the sidebar is hidden. S2 may provide
 * src/features/communities/components/CommunityHeaderCard.tsx (same props) with the join button.
 */
export function CommunityHeaderCard({ slug, community }: CommunitySlotProps) {
  const { isError } = useCommunity(slug)
  if (!community && isError) {
    const name = humanizeSlug(slug)
    return (
      <Card padding="sm" className="flex items-center gap-3">
        <CommunityIcon name={name} size={40} />
        <span className="truncate text-section text-text">{name}</span>
      </Card>
    )
  }
  return (
    <Card padding="sm" className="flex items-center gap-3">
      {community ? (
        <CommunityIcon name={community.name} src={community.iconUrl} id={community.id} brandColor={community.brandColor} size={40} />
      ) : (
        <Skeleton width={40} height={40} />
      )}
      <div className="min-w-0 flex-1">
        {community ? (
          <>
            <Link to={`/${community.slug ?? slug}/about`} className="block truncate text-section text-text">
              {community.name}
            </Link>
            <p className="text-meta text-muted">
              {plural(community.memberCount, '{count} member', '{count} members', { count: formatCount(community.memberCount) })}
            </p>
          </>
        ) : (
          <>
            <Skeleton height={16} className="mb-1.5 w-1/2" />
            <Skeleton height={12} className="w-1/4" />
          </>
        )}
      </div>
    </Card>
  )
}
